import { EXPRESS_API } from 'configs/api/expressApi';
import { successToast } from 'lib/components/toasts/success';
import { useToastError } from 'lib/hooks';
import { useMutation, useQueryClient } from 'react-query';
import { BASE_KEY } from './backgroundKeys';

export interface IDeleteBackgroundParams {
  id: number;
}

export const deleteBackground = async (
  params: IDeleteBackgroundParams
): Promise<void> => {
  const { id } = params;
  await EXPRESS_API.delete(`/backgrounds/${id}`);
};

export const useDeleteBackgroundMutation = (onSuccess?: () => void) => {
  const queryClient = useQueryClient();
  const { showError } = useToastError();

  return useMutation(deleteBackground, {
    onSuccess: async () => {
      await queryClient.refetchQueries({
        queryKey: BASE_KEY,
        exact: false,
      });
      onSuccess?.();
      successToast({
        title: `Background has been successfully deleted!`,
      });
    },
    onError: error =>
      showError(
        error || `An error occurred while trying to delete the background.`
      ),
  });
};
